module.exports = __webpack_public_path__ + "static/media/warning.e5cdd357.svg";